const replaceFootnotes = text => (text ? text.replace(/\[\^.]/g, "*") : "");

module.exports = replaceFootnotes;
